export default __webpack_public_path__ + "static/media/img2.d973ad45.svg";